module.exports = __webpack_public_path__ + "img/comfimeNo.39ca3f0e.svg";